import {ElMessage, ElMessageBox} from "element-plus";

// 时间格式化（年月日时分秒）
export function timestampToTime(time) {
    if ("" === time || time === null || time === undefined) {
        return "";
    } else {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;
        return  y + '-' + m + '-' + d+' '+h+':'+minute+ ':' + second;
    }
}

// 时间格式化(年月日)
export function timestampToDate(time) {
    if ("" === time || time === null || time === undefined) {
        return "";
    } else {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return  y + '-' + m + '-' + d;
    }
}

// 时间格式化(年月日)
export function getTodayDate() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return  y + '-' + m + '-' + d;
}

// 通过出生年月获取年龄
export function calculateAge(birth) {
    let today = new Date(); // 获取当前日期
    let birthdate = new Date(birth);
    let birthYear = birthdate.getFullYear(); // 提取生日的年份
    if (today.getMonth() < birthdate.getMonth()) {
        return today.getFullYear() - birthYear; // 如果今天月份小于生日月份，则表明还未达到该年龄
    } else if ((today.getMonth() === birthdate.getMonth()) && (today.getDay() < birthdate.getDay())) {
        return today.getFullYear() - birthYear; // 如果今天月份等于生日月份并且今天日子小于生日日子，也表明还未达到该年龄
    } else {
        return today.getFullYear() - birthYear + 1; // 否则就已经达到了指定年龄
    }
}

export function alertMsg (msg, icon) {
    ElMessageBox.confirm(msg, "温馨提示", {
        confirmButtonText: '确定',
        type: icon,
    }).then(r => {
        console.log(r)
    }).catch(cancel=>{
        console.log(cancel)
    })
}

export function message (msg, icon) {
    if ("success" === icon) {
        ElMessage.success(msg);
    } else if ("info" === icon) {
        ElMessage.info(msg);
    } else if ("error" === icon) {
        ElMessage.error(msg);
    } else if ("warning" === icon) {
        ElMessage.warning(msg);
    }
}

export function messageHtml (msg, icon) {
    if ("success" === icon) {
        ElMessage.success({
            dangerouslyUseHTMLString: true,
            message: msg,
        });
    } else if ("info" === icon) {
        ElMessage.info({
            dangerouslyUseHTMLString: true,
            message: msg,
        });
    } else if ("error" === icon) {
        ElMessage.error({
            dangerouslyUseHTMLString: true,
            message: msg,
        });
    } else if ("warning" === icon) {
        ElMessage.warning({
            dangerouslyUseHTMLString: true,
            message: msg,
        });
    }
}

export function chackFiled (param) {
    if (param === "" || param === null || param === undefined) {
        return false;
    } else {
        return true;
    }
}

export function chackAlertMsg (param, msg, icon) {
    if (param === "" || param === null || param === undefined) {
        if ("success" === icon) {
            ElMessage.success(msg);
        } else if ("info" === icon) {
            ElMessage.info(msg);
        } else if ("error" === icon) {
            ElMessage.error(msg);
        } else if ("warning" === icon) {
            ElMessage.warning(msg);
        }
        return false;
    } else {
        return true;
    }
}
export function chackMsg (param, msg, icon) {
    if (param === "" || param === null || param === undefined) {
        ElMessageBox.confirm(msg,"温馨提示",{
            confirmButtonText: '确定',
            type: icon,
        }).then(r => {
            console.log(r)
        }).catch(cancel=>{
            console.log(cancel)
        })
        return false;
    } else {
        return true;
    }
}

export function chackNumber (param, msg, icon) {
    if (param === "" || param === null || param === undefined) {
        ElMessageBox.confirm(msg,"温馨提示",{
            confirmButtonText: '确定',
            type: icon,
        }).then(r => {
            console.log(r)
        }).catch(cancel=>{
            console.log(cancel)
        })
        return false;
    } else if (param !== "" && param !== null && param !== undefined) {
        return true;
    } else {
        return true;
    }
}



// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}


/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    result = result.substring(0, result.lastIndexOf("&"));
    return result
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}
